exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-logo[data-v-7606939e]{z-index:999;margin-right:auto;height:28px}.header-logo .logo[data-v-7606939e]{width:100%;margin:0 auto}@media (max-width:400px){.header-logo[data-v-7606939e]{margin-left:5px}}", ""]);

// exports
